export default "__VITE_ASSET__DEhEQaNy__"